import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { FaUbuntu } from "react-icons/fa";

interface UbuntuUpdateProps {
  duration?: number;
}

const UbuntuUpdate = ({ duration = 60 }: UbuntuUpdateProps) => {
  const [progress, setProgress] = useState(0);
  const [animationStep, setAnimationStep] = useState(0);

  // Progress animation (változatlan)
  useEffect(() => {
    const increment = 100 / (duration * 20);
    const interval = setInterval(() => {
      setProgress((prev) => Math.min(prev + increment, 100));
    }, 50);
    
    return () => clearInterval(interval);
  }, [duration]);

  // Dot animation: 0-tól 10-ig léptetünk, majd újraindul (egy ciklus 11 másodperc)
  useEffect(() => {
    const interval = setInterval(() => {
      setAnimationStep((prev) => (prev + 1) % 11);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // A pont színének meghatározása:
  // Ha animationStep <= 5: az összes, index < animationStep pont színes, a többi fehér.
  // Ha animationStep > 5: az összes, index >= (animationStep - 5) pont színes, a többi fehér.
  const getDotColor = (index: number) => {
    if (animationStep <= 5) {
      return index < animationStep ? '#E95420' : '#ffffff';
    } else {
      return index >= (animationStep - 5) ? '#E95420' : '#ffffff';
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: '#2d0922',
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontFamily: 'Monospace',
        textAlign: 'center',
      }}
    >
      {/* Ubuntu szöveg és FaUbuntu ikon, az ikon a szöveg jobb felső sarkában */}
      <Box sx={{ position: 'relative', display: 'inline-block', mb: 2 }}>
        <Typography 
          variant="h2" 
          sx={{ fontFamily: 'Ubuntu, sans-serif, OpenType-based humanist typeface' }}
        >
          ubuntu
        </Typography>
        <Box sx={{ position: 'absolute', top: 0, right: -25 }}>
          <FaUbuntu size={30} />
        </Box>
      </Box>

      {/* Pont animáció */}
      <Box sx={{ display: 'flex', gap: 3, mb: 8 }}>
        {[...Array(5)].map((_, index) => (
          <Box
            key={index}
            sx={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              backgroundColor: getDotColor(index),
              transition: 'background-color 0.3s ease',
            }}
          />
        ))}
      </Box>

      <Typography variant="body1" sx={{ mb: 2 }}>
        Unattended-upgrade in progress during shutdown, please don't turn off the computer
      </Typography>
    </Box>
  );
};

export default UbuntuUpdate;
